import type DocumentTypeSectionView from '@UI/Store/OrganizationWorkflows/Views/DocumentTypeSectionView';

type DependencyOption = {
	readonly label: string;
	readonly value: string;
};

/** The title a section is shown under: path '' is the template's fields outside any section. */
export const GENERAL_SECTION_TITLE = 'Champs généraux (hors section)';

export const resolveSectionTitle = (section: DocumentTypeSectionView): string =>
	section.path === '' ? GENERAL_SECTION_TITLE : section.title;

/**
 * What a section may wait for: every other section as a whole, and each field of those sections.
 * The section itself and its own fields are left out — a section cannot wait for itself.
 */
const buildDependencyOptions = (
	sections: readonly DocumentTypeSectionView[],
	ownPath: string,
): readonly DependencyOption[] =>
	sections
		.filter((section) => section.path !== ownPath)
		.flatMap((section) => [
			{ label: resolveSectionTitle(section), value: section.path },
			...section.fields.map((field) => ({
				label: `${resolveSectionTitle(section)} › ${field.label}`,
				value: field.path,
			})),
		]);

export default buildDependencyOptions;
